const INITIAL_STATE = {
  data: {},
  fieldOfficeDetail: [],
  errors: {},
}
  
const zipcodeCheck = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'CHECK_ZIPCODE_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'CHECK_ZIPCODE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'FIELD_OFFICE_DETAIL_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, fieldOfficeDetail: action.data }
  case 'FIELD_OFFICE_DETAIL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default zipcodeCheck;